import GenerateAPI from '../generate.js'
const config = {
    list: {
        url: '/client/record/feelist',
        apiType: 'check',
    },
    detail: {
        url: '/client/record/feelist/detail',
        apiType: 'check',
    },
    ticket: {
        url: '/client/record/feelist/ticket',
        apiType: 'check',
    },
    download: {
        url: '/client/record/getTicketImg',
        method: 'get',
        responseType: 'blob',
    },
}
const apiPaySituation = GenerateAPI.generate(config)

export default apiPaySituation
